export const ChartIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.916 8.75L10.416 11.25L8.74935 9.58333L6.24935 12.0833"
        stroke="#05796B"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0833 3.75H6.95C5.82989 3.75 5.26984 3.75 4.84202 3.96799C4.46569 4.15973 4.15973 4.46569 3.96799 4.84202C3.75 5.26984 3.75 5.82989 3.75 6.95V13.05C3.75 14.1701 3.75 14.7302 3.96799 15.158C4.15973 15.5343 4.46569 15.8403 4.84202 16.032C5.26984 16.25 5.82989 16.25 6.95 16.25H13.05C14.1701 16.25 14.7302 16.25 15.158 16.032C15.5343 15.8403 15.8403 15.5343 16.032 15.158C16.25 14.7302 16.25 14.1701 16.25 13.05V7.91667"
        stroke="#05796B"
        strokeLinecap="round"
      />
      <path
        d="M15.417 3C16.2913 3 17.0008 3.70871 17.001 4.58301C17.001 5.45746 16.2914 6.16699 15.417 6.16699C14.5427 6.16682 13.834 5.45735 13.834 4.58301C13.8342 3.70882 14.5428 3.00018 15.417 3Z"
        stroke="#05796B"
        strokeLinecap="round"
      />
    </svg>
  );
};
